<template>
    <d-navbar-nav class="flex-row">
        <li class="nav-item border-left dropdown notifications mr-0">
            <d-link to="/help">
                <a class="nav-link nav-link-icon text-center">
                    <div class="nav-link-icon__wrapper">
                        <i class="fas fa-question-circle text-muted"></i>
                    </div>
                </a>
            </d-link>
        </li>
        <notification-center v-if="showNotifications" />
        <li v-if="userInfo.created_at" class="nav-item dropdown">
            <a v-on-clickout="hideNav" @click="isActive = !isActive" class="nav-link dropdown-toggle text-nowrap px-3">
                <div class="user-icon ml-0 mr-2">
                    {{ userInfo.first_name | firstLetter }}{{ userInfo.last_name | firstLetter }}
                </div>
                <span class="d-none d-md-inline-block">{{ userInfo.full_name }}</span>
            </a>
            <b-collapse class="dropdown-menu dropdown-menu-small" id="user-actions" v-model="isActive">
                <d-navbar-nav>
                    <d-dropdown-item to="/user-profile"><i class="material-icons">&#xE7FD;</i> Profile</d-dropdown-item>
                    <d-dropdown-item v-if="checkSidebarPermission(permissionTypes.userRead)" to="/users"><i class="material-icons">&#xea21;</i> Users</d-dropdown-item>
                    <d-dropdown-item v-if="checkPermission(permissionTypes.agreementRead)" to="/agreement"><i class="material-icons">&#xe876;</i> Agreements</d-dropdown-item>
                    <d-dropdown-item v-if="checkPermission(permissionTypes.invoiceRead)" to="/invoice"><i class="fa">&#xf15b;</i> Invoices</d-dropdown-item>
                    <d-dropdown-item v-if="checkPermission(permissionTypes.billingRead)" to="/billing"><i class="material-icons">&#xe326;</i> Billing</d-dropdown-item>
                    <d-dropdown-item v-if="checkPermission(permissionTypes.apiRead)" to="/api-access"><i class='fas fa-server'></i> API access</d-dropdown-item>
                    <d-dropdown-item to="/js-snippet"><i class="material-icons">&#xe86f;</i> Ivanhoe.io tag</d-dropdown-item>
                    <d-dropdown-divider />
                    <div class="dropdown-item text-danger" @click="signOut">
                        <i class="material-icons text-danger">&#xE879;</i> Logout
                    </div>
                </d-navbar-nav>
            </b-collapse>
        </li>
    </d-navbar-nav>
</template>

<script>
    import { UserService, AuthService } from '@/main';
    import { mixin as clickout } from 'vue-clickout';
    import permissions from '../../../mixins/permissions';
    import NotificationCenter from '@/components/common/NotificationCenter.vue';

    export default {
        mixins: [clickout, permissions],

        data() {
            return {
                isActive: false,
            }
        },

        components: {
            NotificationCenter
        },

        methods: {
            async signOut() {
                const signOut = await AuthService.signOut()
                if (signOut) {
                    $cookies.remove('token');
                    this.$router.go()
                } else {
                    return false
                }
            },

            hideNav() {
                this.isActive = false
            },
        },

        computed: {
            userInfo () {
                return this.$store.getters.userInfo
            },
            showNotifications () {
                return this.userInfo.role && this.userInfo.role.name !== 'Accountant'
            },
        },

        watch: {
            $route(to, from) {
                this.hideNav()
            }
        },
    }
</script>
